import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface ButtonProps {
  fn: () => void;
  copy: string;
}

interface Props {
  open: boolean;
  confirmButton?: ButtonProps;
  cancelButton?: ButtonProps;
  handleClose: () => void;
  dialogueTitle?: string;
  dialogueContent?: string;
}

/**
 * Reusable alert dialogue component.
 *
 * Based on this example: https://mui.com/material-ui/react-dialog/#alerts
 */
const AlertDialog: React.FC<Props> = ({
  open,
  handleClose,
  dialogueTitle,
  dialogueContent,
  confirmButton,
  cancelButton,
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {dialogueTitle && (
          <DialogTitle id="alert-dialog-title">{dialogueTitle}</DialogTitle>
        )}
        {dialogueContent && (
          <DialogContent>
            <DialogContentText id="alert-dialog-description" color="primary">
              {dialogueContent}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          {cancelButton && (
            <Button
              onClick={() => {
                cancelButton.fn();
              }}
            >
              {cancelButton.copy}
            </Button>
          )}
          {confirmButton && (
            <Button
              onClick={() => {
                confirmButton.fn();
              }}
              autoFocus
            >
              {confirmButton.copy}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AlertDialog;
